// import React from "react";
// import { Box, useTheme,IconButton } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
// import CloseIcon from "@mui/icons-material/Close";

// const DocumentUpload = ({
//   onFileSelect,
//   fileName,
//   isUploading = false,
//   error = null,
//   accept = ".pdf,.doc,.docx",
//   disabled = false,
//   required = false,
//   label = null,
// }) => {
//   const theme = useTheme();
//   const { t } = useTranslation();
//   const fileInputRef = React.useRef(null);

//   const handleClick = () => {
//     if (!disabled && !isUploading && fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file && onFileSelect) {
//       onFileSelect(file);
//     }
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
    
//     if (disabled || isUploading) return;
    
//     const files = e.dataTransfer.files;
//     if (files.length > 0 && onFileSelect) {
//       onFileSelect(files[0]);
//     }
//   };

//   return (
//     <Box sx={{ mb: 2 }}>
//       {label && (
//         <Box sx={{ mb: 1 }}>
//           <label style={{ 
//             color: "#626F86", 
//             fontSize: "15px",
//             fontWeight: 500 
//           }}>
//             {label}
//             {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
//           </label>
//         </Box>
//       )}
      
//       <Box
//         onClick={handleClick}
//         onDragOver={handleDragOver}
//         onDrop={handleDrop}
//         sx={{
//           width: "100%",
//           minHeight: 120,
//           border: error 
//             ? "2px dashed #ff4444" 
//             : "2px dashed #091E4224",
//           borderRadius: "8px",
//           backgroundColor: "#ffffff",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           cursor: disabled || isUploading ? "not-allowed" : "pointer",
//           transition: "all 0.2s ease-in-out",
//           "&:hover": {
//             borderColor: disabled || isUploading ? "#091E4224" : theme.palette.primary.main,
//             backgroundColor: disabled || isUploading ? "#ffffff" : "#f8f9fa",
//           },
//           opacity: disabled ? 0.6 : 1,
//         }}
//       >
//         <AttachFileIcon 
//           sx={{ 
//             fontSize: 24, 
//             color: "#626F86", 
//             mb: 1 
//           }} 
//         />
        
//         <Box sx={{ 
//           display: "flex", 
//           alignItems: "center", 
//           gap: 0.5,
//           textAlign: "center"
//         }}>
//           <span style={{ 
//             color: "#626F86", 
//             fontSize: "14px",
//             fontFamily: "Poppins, sans-serif"
//           }}>
//             {t("dragFileHere")}
//           </span>
//           <span style={{ 
//             color: theme.palette.primary.main, 
//             fontSize: "14px",
//             fontFamily: "Poppins, sans-serif",
//             textDecoration: "underline",
//             cursor: "pointer"
//           }}>
//             {t("browseFiles")}
//           </span>
//         </Box>
//         <Box sx={{ mt:0 }}>
//   <span style={{
//     color: "#999",
//     fontSize: "12px",
//     fontFamily: "Poppins, sans-serif",
//   }}>
//     {t("onlyPdfAndImages")}
//   </span>
// </Box>
        
     

//         {fileName && (
//   <Box
//     sx={{
//       position: "relative",
//       mt: 1.5,
//       px: 2,
//       // py: 1,
//       borderRadius: "6px",
//       // backgroundColor: "#F4F5F7",
//       display: "inline-flex",
//       alignItems: "center",
//       justifyContent: "center",
//     }}
//   >
//     <span
//       style={{
//         fontSize: "13px",
//         color: "#172B4D",
//         fontWeight: 500,
//         textAlign: "center",
//         wordBreak: "break-all",
//         maxWidth: 220,
//       }}
//     >
//       {fileName}
//     </span>

//     <IconButton
//       size="small"
//       onClick={(e) => {
//         e.stopPropagation();
//         if (onFileSelect) onFileSelect(null); // clear selected file
//       }}
//       sx={{
//         position: "absolute",
//         top: -8,
//         right: -8,
//         backgroundColor: "#fff",
//         borderRadius: "50%",
//         boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//         padding: "2px",
//         "&:hover": {
//           backgroundColor: "#f2f2f2",
//         },
//       }}
//     >
//       <CloseIcon sx={{ fontSize: 16, color: "#ff4d4f" }} />
//     </IconButton>
//   </Box>
// )}
//         {isUploading && (
//           <Box sx={{ 
//             mt: 1, 
//             fontSize: "13px", 
//             color: theme.palette.primary.main,
//             fontWeight: 500
//           }}>
//             {t("uploading")}
//           </Box>
//         )}
//       </Box>
      
//       <input
//         ref={fileInputRef}
//         type="file"
//         accept={accept}
//         hidden
//         onChange={handleFileChange}
//         disabled={disabled || isUploading}
//       />
      
//       {error && (
//         <Box sx={{ 
//           fontSize: 12, 
//           color: "#ff4444", 
//           mt: 0.5,
//           fontFamily: "Poppins, sans-serif"
//         }}>
//           {error}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default DocumentUpload;




import React from "react";
import { Box, useTheme, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";

const DocumentUpload = ({
  onFileSelect,
  fileName,
  isUploading = false,
  error = null,
  accept = ".pdf,.jpg,.jpeg,.png",
  disabled = false,
  required = false,
  label = null,
  fileIcon
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const fileInputRef = React.useRef(null);

  const handleClick = () => {
    if (!disabled && !isUploading && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onFileSelect) {
      onFileSelect(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (disabled || isUploading) return;

    const files = e.dataTransfer.files;
    if (files.length > 0 && onFileSelect) {
      onFileSelect(files[0]);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      {label && (
        <Box sx={{ mb: 1 }}>
          <label
            style={{
              color: "#626F86",
              fontSize: "15px",
              fontWeight: 500,
            }}
          >
            {label}
            {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
          </label>
        </Box>
      )}

      {/* Upload box */}
      <Box
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        sx={{
          width: "100%",
          minHeight: 120,
          border: error
            ? "2px dashed #ff4444"
            : "2px dashed #091E4224",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: disabled || isUploading ? "not-allowed" : "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            borderColor:
              disabled || isUploading
                ? "#091E4224"
                : theme.palette.primary.main,
            backgroundColor:
              disabled || isUploading ? "#ffffff" : "#f8f9fa",
          },
          opacity: disabled ? 0.6 : 1,
          position: "relative",
        }}
      >
        {/* If file is uploaded → show name + close */}
        {fileName ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            
              gap: 1,
              position: "relative",
              backgroundColor: "#F4F5F7",
              borderRadius: "6px",
              px: 2,
              py: 1,
              maxWidth: "90%",
            }}
          >
            <Box sx={{display:"flex",flexDirection:"column",alignItems:'center',justifyContent:"center"}}>
            {fileIcon && (
  <img 
    src={fileIcon} 
    alt="doc-icon" 
    style={{ width: 35, height: 35, marginBottom: 5 }}
  />
)}
            <span
              style={{
                fontSize: "13px",
                color: "#172B4D",
                fontWeight: 500,
                textAlign: "center",
                wordBreak: "break-all",
              }}
            >
              {fileName}
            </span>
            </Box>

            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (onFileSelect) onFileSelect(null);
              }}
              sx={{
                position: "absolute",
                top: -10,
                right: -10,
                backgroundColor: "#fff",
                borderRadius: "50%",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                padding: "2px",
                "&:hover": {
                  backgroundColor: "#f2f2f2",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 16, color: "#ff4d4f" }} />
            </IconButton>
          </Box>
        ) : (
          <>
            <AttachFileIcon
              sx={{
                fontSize: 24,
                color: "#626F86",
                mb: 1,
              }}
            />

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                textAlign: "center",
              }}
            >
              <span
                style={{
                  color: "#626F86",
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {t("dragFileHere")}
              </span>
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {t("browseFiles")}
              </span>
            </Box>
          </>
        )}

        {isUploading && (
          <Box
            sx={{
              mt: 1,
              fontSize: "13px",
              color: theme.palette.primary.main,
              fontWeight: 500,
            }}
          >
            {t("uploading")}
          </Box>
        )}
      </Box>

      {/* ✅ File type note outside the upload box */}
      <Box sx={{ mt: 1 }}>
        <span
          style={{
            color: "#999",
            fontSize: "12px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {t("onlyPdfAndImages")}
        </span>
      </Box>

      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        hidden
        onChange={handleFileChange}
        disabled={disabled || isUploading}
      />

      {error && (
        <Box
          sx={{
            fontSize: 12,
            color: "#ff4444",
            mt: 0.5,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {error}
        </Box>
      )}
    </Box>
  );
};

export default DocumentUpload;

